﻿import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederLutDto from '../Models/VeilederLutDto';
import { VeilederLutAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import { BoksResultatA } from '../Ids';
import HelsefagValg from '../Utilities/D-HelsefagValg';
import Valg from '../../Shared/Scripts/Models/Valg';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';
import { LarestedViewModel } from '../Utilities/LutApi';


interface ResultatOwnProps {
    visEkstraboksHandler: any,
    helsefagValg: Valg<string> | undefined,
    landMerknad: string,
    larested?: Larested,
}

export interface Larested {
    LarestedWebAdresse: string;
    UtdanningListe: LarestedViewModel['UtdanningsoppleggListe'];
    LarestedKundeveiledningstekst: string,
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function ResultatAComponent(props: ResultatDisplayProps): JSX.Element {
    const { epiContext, helsefagValg, landMerknad, larested } = props;

    const [visEkstraboks, setVisEkstraboks] = useState(false);
    useEffect(() => {
        updateLiveMessage();
    }, []);
    function onVisEkstraboks(): void {
        if (visEkstraboks) {
            setVisEkstraboks(false);
            props.visEkstraboksHandler(false);
        } else {
            setVisEkstraboks(true);
            props.visEkstraboksHandler(true);
        }
    }

    let overskriftMerknadLarested = contentResolver(epiContext, 'overskriftMerknad');

    return (
        <div id={BoksResultatA} className="c-veileder__panel c-veileder__panel-paddingBottom-killer c-veileder__panel--lilac">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h3 className="c-veileder__tittel">
                        {contentResolver(epiContext, 'tittelVenstreResultatJa')}
                    </h3>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <h4 className="c-veileder--overskrift c-veileder--overskrift-kjempestor c-veileder--overskrift-litt-margin">
                        {contentResolver(epiContext, 'tittelHoyreResultatJa')}
                    </h4>
                    <div className="c-veileder--tekstomraade">
                        {contentResolver(epiContext, 'infoResultatJa')}
                    </div>
                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel---secondary-lilac c-veileder__panel---secondary-lilac-no-header">
                <div className="c-veileder__content">
                    {(landMerknad || larested?.LarestedKundeveiledningstekst) &&
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-mellom c-veileder--overskrift-litt-margin">
                            {contentResolver(epiContext, 'tittelMerknadResultatJa')}
                        </h4>
                    }
                    {landMerknad &&
                        <div className="c-veileder--tekstomraade">
                            {<div dangerouslySetInnerHTML={{ __html: landMerknad }} />}
                        </div>
                    }
                    {overskriftMerknadLarested && larested?.LarestedKundeveiledningstekst &&
                        <h5 className="c-veileder--overskrift c-veileder--overskrift-litt-margin">{overskriftMerknadLarested}</h5>
                    }
                    {larested?.LarestedKundeveiledningstekst &&
                        <div className="c-veileder--tekstomraade">
                            {<div dangerouslySetInnerHTML={{ __html: larested?.LarestedKundeveiledningstekst }} />}
                        </div>
                    }
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <div className="c-veileder--tekstomraade">
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-mellom c-veileder--overskrift-litt-margin">
                            {contentResolver(epiContext, 'tittelStudiestotteResultatJa')}
                        </h4>
                        <div className="c-veileder--tekst">
                            {contentResolver(epiContext, 'infoStudiestotteResultatJa')}
                        </div>
                    </div>
                    {helsefagValg?.value === HelsefagValg.d1_ja &&
                        <div className="c-veileder--tekstomraade">
                            <h4 className="c-veileder--overskrift c-veileder--overskrift-mellom c-veileder--overskrift-litt-margin">
                                {contentResolver(epiContext, 'tittelHelsefagResultatJa')}
                            </h4>
                            <div className="c-veileder--tekst">
                                {contentResolver(epiContext, 'infoHelsefagResultatJa')}
                            </div>
                        </div>
                    }

                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder--div-even-bigger-spacer">
                <div className="c-veileder__content">
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <div className="c-veileder--tekstomraade">
                        <button type="button"
                            className="c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--lenke-aubergine c-knapp--icon-after c-knapp--pil-opp-aubergine"
                            onClick={onVisEkstraboks}>
                                {contentResolver(epiContext, 'lenketekstResultatJa')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederLutDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederLutAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(ResultatAComponent);
